import { Component } from '@angular/core';
import {
 MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose
} from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatButton } from '@angular/material/button';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'fs-logout-dialog',
    template: `
    <h2 mat-dialog-title>{{'LOGOUT.TITLE' | translate}}</h2>
    <mat-dialog-content>{{'LOGOUT.CONFIRMATION' | translate}}</mat-dialog-content>
    <mat-dialog-actions class="btn-uppercase align-right">
      <button mat-button [matDialogClose]="false" color="primary">{{'COMMON.BUTTONS.CANCEL' | translate}}</button>
      <button mat-button [matDialogClose]="true" color="primary">{{'COMMON.BUTTONS.CONFIRM' | translate}}</button>
    </mat-dialog-actions>
  `,
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatDialogActions, MatButton, MatDialogClose, TranslatePipe]
})
export class LogoutDialogComponent {
}
